/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/call-list';
 */
export const layoutConfig = {
    styles: {
        borderlessSearch: false,
    },
    dimensions: {
        maxHeight: 460,
        padding: 0
    },
    columnWidth: {
        taskId: 90,
        toDotypeAndSubType: 100,
        addedDate: 100,
        dueDate: 90,
        status: 90,
        
        // special columns
        _groupActions: 70, // group actions column
    },
    filterFlyoutWidths: {
        toDotypeAndSubType: 200,
    },
    valueColors: {
        status: {
            closed: '#59ad00',
            open: '#e7aa00',
        },
    },
    actionIcons: {},
    highlightRow: 'hasPassedDueDate'
};
